import { ModelBase } from '../../core/model/model-base';
import { DocumentVisibilityKind } from './const/enum';

export abstract class DocumentConnectionBase extends ModelBase {
  caption: string;
  document: File;
  size: number;
  uploadedDate: Date;
  documentId: string;
  sortOrder: number;
  visibility: DocumentVisibilityKind;
  visibiltyText: string;

  toString(culture?: string): string {
    return this.caption || '';
  }
}

export abstract class DocumentConnection<ConnectionType> extends DocumentConnectionBase {
  connectionType: ConnectionType;
  abstract get connectionTypeText(): string;

  toJSON() {
    return {
      caption: this.caption,
      document: this.document,
      size: this.size,
      uploadedDate: this.uploadedDate,
      documentId: this.documentId,
      sortOrder: this.sortOrder,
      connectionType: this.connectionType,
      visibility: this.visibility,
      visibiltyText: this.visibiltyText,
    };
  }
}
